/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getFlyer = /* GraphQL */ `
  query GetFlyer($id: ID!) {
    getFlyer(id: $id) {
      id
      title
      contact
      startDate
      endDate
      address
      tel
      website
      permalink
      logoImage
      images
      sponsor
      status
      createdAt
      updatedAt
    }
  }
`;
export const listFlyers = /* GraphQL */ `
  query ListFlyers(
    $filter: ModelFlyerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFlyers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        contact
        startDate
        endDate
        address
        tel
        website
        permalink
        logoImage
        images
        sponsor
        status
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
